(function() {
	document.addEventListener("DOMContentLoaded", function(event) {
		const carousel = document.getElementById("settlement_carousel");
		if (carousel) {
			const carouselItems = carousel.querySelectorAll("li")
			let visibleItem = 0

			function swapItems() {
				for (const el of carouselItems) {
					el.classList.remove("show")
				}

				carouselItems[visibleItem].classList.add('show')
				visibleItem += 1

				if (visibleItem > carouselItems.length - 1) {
					visibleItem = 0
				}
			}

			swapItems()

			const interval = setInterval(swapItems, 5500);
		}
	})

	const inViewListener = new IntersectionObserver(entries => {
	  entries.forEach(entry => {
	    if ((entry.isIntersecting || entry.intersectionRatio)) {
				entry.target.classList.add("loaded");
	    }
	  });
	}, { root: null, rootMargin: "0px", threshold: 0.25 });

	const testimonialsListener = new IntersectionObserver(entries => {
	  entries.forEach(entry => {
	    if ((entry.isIntersecting || entry.intersectionRatio)) {
        document.querySelectorAll(".testimonial-controls a").forEach(el => el.classList.remove("active"));
        document.querySelector(`.testimonial-controls a[href="#${entry.target.id}"]`).classList.add("active");
	    }
	  });
	}, { root: null, rootMargin: "0px", threshold: 1 });

	const animations = document.querySelectorAll("[data-animates]");
	for (const animation of animations) {
		inViewListener.observe(animation);
	}

  const testimonials = document.querySelectorAll(".testimonial");

  for (const testimonial of testimonials) {
    testimonialsListener.observe(testimonial);
  }

  const testimonialWrapper = document.querySelector(".all-testimonials");
  if (testimonialWrapper) {
    function setTestimonialHeight() {
      const expectedHeight = window.getComputedStyle(testimonialWrapper).height
      testimonialWrapper.style.setProperty("--expected-height", expectedHeight);
    }
    document.addEventListener("DOMContentLoaded", setTestimonialHeight);
    window.addEventListener("resize", setTestimonialHeight);
  }
})()
